import React from 'react';
import { Layers } from 'lucide-react';
import { getIntentTone } from './intentTone';
import EntityIdentityRow from './EntityIdentityRow';
import ValueChangeBlock from './ValueChangeBlock';

export default function EntityChangeHeader({
  primaryEntity,
  breadcrumb,
  actionLabel,
  intent,
  valueChangeDisplay,
  valueAfterRaw,
  onChangeValueAfterRaw,
  afterEditable = false,
  itemsCount,
  entityTypePlural,
}) {
  const tone = getIntentTone(intent);
  const count = Number(itemsCount || 0);
  const isMulti = count > 1;

  if (!isMulti) {
    return (
      <div className="mb-5 rounded-2xl overflow-hidden border border-white/10 bg-white/5">
        <div className="px-4 py-3 flex items-center gap-4">
          <div className="min-w-0 flex-1">
            <EntityIdentityRow entity={primaryEntity} breadcrumb={breadcrumb} intent={intent} size="lg" />
          </div>
          {actionLabel ? (
            <span
              className="shrink-0 px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap border border-white/10"
              style={{ background: tone.pillBg, color: tone.surface }}
            >
              {actionLabel}
            </span>
          ) : null}
        </div>
        <div className="border-t border-white/10" />
        <div className="px-0">
          <ValueChangeBlock
            valueChangeDisplay={valueChangeDisplay}
            intent={intent}
            embedded
            afterEditable={afterEditable}
            afterRawValue={valueAfterRaw}
            onAfterRawChange={onChangeValueAfterRaw}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="mb-5 rounded-2xl overflow-hidden border border-white/10 bg-white/5">
      <div className="px-4 py-3 flex items-center gap-4">
        <div className="shrink-0 w-11 h-11 rounded-lg flex items-center justify-center border border-white/10" style={{ background: tone.bg }}>
          <Layers className="w-[22px] h-[22px]" style={{ color: tone.text }} aria-hidden />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-[10px] font-medium tracking-[0.6px] uppercase text-white/50 leading-none">
            {(entityTypePlural || 'ITEMS').toUpperCase()}
          </div>
          <div className="mt-[2px] text-[15px] font-medium text-white truncate">
            {count} {(entityTypePlural || 'items').toLowerCase()} para revisar
          </div>
        </div>
        {actionLabel ? (
          <span
            className="shrink-0 px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap border border-white/10"
            style={{ background: tone.pillBg, color: tone.surface }}
          >
            {actionLabel}
          </span>
        ) : null}
      </div>
    </div>
  );
}

